import { checkAuthentication } from './middleware';

export const authorRoutes = [
    {
        path: '/authors',
        name: 'AuthorList',
        component:  () => import(/* webpackChunkName: "author-route" */ '../views/authors/AuthorList'),
        beforeEnter: checkAuthentication
    },
    // {
    //     path: '/authors/create/:id',
    //     name: 'CreateAuthor',
    //     component: () => import(/* webpackChunkName: "author-route" */ '../views/authors/CreateAuthor'),
    //     props: true,
    //     beforeEnter: checkAuthentication
    // },
    {
        path: '/authors/view/:id',
        name: 'ViewAuthor',
        component: () => import(/* webpackChunkName: "author-route" */ '../views/authors/ViewAuthor'),
        props: true,
        beforeEnter: checkAuthentication
    },

]